export default __webpack_public_path__ + "static/media/component_speaker.7f1838d9.png";